import { render, staticRenderFns } from "./service-dependencies.vue?vue&type=template&id=18dbe79e&scoped=true&"
import script from "./service-dependencies.vue?vue&type=script&lang=js&"
export * from "./service-dependencies.vue?vue&type=script&lang=js&"
import style0 from "./service-dependencies.vue?vue&type=style&index=0&id=18dbe79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbe79e",
  null
  
)

export default component.exports